import axios from 'axios';

export async function getApgJWTEqoute() {
  try {
    console.log('Fetching n c apg token');
    const response = await axios.post(process.env.REACT_APP_BASE_URL+'/v1/oauth/jwt', {headers: {
      "Content-Type": "application/json"
  }}, {auth:{
      username: process.env.REACT_APP_LOGINASSISTANT_HASH,
      password: process.env.REACT_APP_EQOUTE_OAUTH_PASSWORD
    }
  });

  const newToken = response.data.token;
  console.log("newtoekn", newToken)
  const expiresIn = 500 //900 is 15 mins

  return newToken;
  } catch (err) {
    console.error('Failed to get APG JWT:', err);
    throw err;
  }
}